module.exports = __webpack_public_path__ + "img/step-1.09e0a75b.jpg";